export enum CustomPeriodicity {
  REVS = 'REVS',
  TICK = 'TICK',
  RANGE = 'RANGE',
  VOLUME = 'VOLUME',
  RENKO = 'RENKO',
}
